import React from 'react'

import { PageSidebar } from '@fortem-monorepo/react-spa'
import { Separator } from '@fortem-monorepo/react-ui'
import {
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@fortem-monorepo/react-ui'
import { Skeleton } from '@fortem-monorepo/react-ui'

import { Section } from '@/pages/funds/ic-report/sections'

export interface ICReportSidebarProps {
  sections: Section[]
  loading?: boolean
}

export const ICReportSidebar: React.FC<ICReportSidebarProps> = ({ sections, loading = false }) => {
  return (
    <PageSidebar sticky>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenu className={'w-full'}>
              {loading &&
                Array.from({ length: 10 }).map((_, index) => {
                  return <Skeleton className={'h-9 w-full mt-1'} key={index} />
                })}
              {!loading &&
                sections.map((section, index) => {
                  return (
                    <React.Fragment key={section.key}>
                      {index !== 0 && <Separator />}
                      <SidebarMenuItem>
                        <SidebarMenuButton
                          className={
                            'text-sm justify-start font-medium text-fortem-orange opacity-100!'
                          }
                          disabled
                        >
                          {section.sectionTitle?.toString()}
                        </SidebarMenuButton>
                        <Separator className={'my-1'} />
                        {section.children.length &&
                          section.children.map((child) => {
                            return (
                              <SidebarMenuItem key={child.key}>
                                <SidebarMenuButton
                                  onClick={() => {
                                    const el = document.getElementById(`icr_${child.key}`)
                                    if (el) {
                                      window.scrollTo({
                                        top: el.offsetTop - 15,
                                        behavior: 'smooth',
                                      })
                                    }
                                  }}
                                  className={
                                    'justify-between overflow-hidden text-ellipsis whitespace-nowrap'
                                  }
                                >
                                  <span>{child.sidebarTitle?.toString()}</span>
                                </SidebarMenuButton>
                              </SidebarMenuItem>
                            )
                          })}
                      </SidebarMenuItem>
                    </React.Fragment>
                  )
                })}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </PageSidebar>
  )
}
